module.exports = __webpack_public_path__ + "static/media/wavebullet.25727b7d.svg";